import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import Routes from "./Routes";
import "./App.css";
import { authUser, signOutUser } from "./libs/awsLib";

//Side menu
import Drawer from 'material-ui/Drawer';
import AppBar from 'material-ui/AppBar';
import MenuItem from 'material-ui/MenuItem'
import {ToolbarGroup} from 'material-ui/Toolbar';
import FlatButton from 'material-ui/FlatButton';
//import * as injectTapEventPlugin from 'react-tap-event-plugin';


//themes

class App extends Component {

  constructor(props) {
    super(props);
    //injectTapEventPlugin();

    this.state = {
      isAuthenticated: false,
      isAuthenticating: true,
      open:false
      
    };
  }
  
  async componentDidMount() {
    try {
      if (await authUser()) {
        this.userHasAuthenticated(true);
      }
    }
    catch(e) {
      alert(e);
    }
  
     this.setState({ isAuthenticating: false });
  }
  
  userHasAuthenticated = authenticated => {
    this.setState({ isAuthenticated: authenticated });
  }

  handleLogout = event => {
    signOutUser();
  
    this.userHasAuthenticated(false);
    
    this.props.history.push("/login");
  }

  //side menu toggle

  handleToggle() {
    this.setState({open: !this.state.open});
    console.log("open")
   }
   
  handleClose() {
     this.setState({open: false}); 
    }
  
  
  render() {

    const childProps = {
      isAuthenticated: this.state.isAuthenticated,
      userHasAuthenticated: this.userHasAuthenticated
    };

    return (
      !this.state.isAuthenticating &&
      <div className="App container">       
          <AppBar
           onLeftIconButtonClick={this.handleToggle.bind(this)}
            iconElementRight={<ToolbarGroup >{             
               this.state.isAuthenticated
              ? [
              <FlatButton key={1} onClick={this.handleLogout}>Logout</FlatButton>,
             
              // The side bar menu 
              <Drawer key={0}
                docked={false}
                open={this.state.open}
                onRequestChange={(open) => this.setState({open})}
                >
              
                <MenuItem key={0}
                onClick={this.handleClose.bind(this)}
                containerElement={<Link to="/topics" />}
                primaryText="Topics" />
                <MenuItem key={1}
                onClick={this.handleClose.bind(this)}
                containerElement={<Link to="/videos" />}
                primaryText="Animation" />
                 <MenuItem key={2}
                onClick={this.handleClose.bind(this)}
                containerElement={<Link to="/affiliatedgroups" />}
                primaryText="Affiliated Groups" />
                {/* <MenuItem key={3}
                onClick={this.handleClose.bind(this)}
                containerElement={<Link to="/textusers" />}
                primaryText="Text Users" /> */}
                <MenuItem key={4}
                onClick={this.handleClose.bind(this)}
                containerElement={<Link to="/viewdata" />}
                primaryText="View Data" />
                <MenuItem key={5}
                onClick={this.handleClose.bind(this)}
                containerElement={<Link to="/pushNotifications" />}
                primaryText="Push Notifications" />
                {/* <MenuItem key={5}
                onClick={this.handleClose.bind(this)}
                containerElement={<Link to="/downloaddata" />}
                primaryText="Download Data" /> */}
                {/* <MenuItem key={6}
                onClick={this.handleClose.bind(this)}
                containerElement={<Link to="/createreport" />}
                primaryText="Create Report" /> */}
               
              </Drawer>]
              : [
                  <FlatButton key={2} href="/signup">
                    Signup
                  </FlatButton>,
                  <FlatButton key={3} href="/login">
                    Login
                  </FlatButton>
                ]}
            </ToolbarGroup>}
             
            /> 
        <Routes childProps={childProps} />
      </div>
    );
  }

}

export default withRouter(App);